<!-- 首頁主要的架構，包含banner、news、fb貼文、特色機種 -->
<!-- banner：themes/frontend/src/modules/home/Banner.vue -->
<!-- 特色機種選單：themes/frontend/src/modules/home/Showcase.vue -->
<!-- 特色機種清單：themes/frontend/src/modules/home/ShowcaseMotor.vue -->

<template>
  <div class="home-page-2022 main-body">
      <Banner v-bind="{ banners }" />
      <Showcase class="section" v-bind="{ styles, series, enableStyleFilter }" />
      <News class="section" v-bind="{ news, videos, settings }" />
      <PageFeed v-bind="{ posts }" />
      <!-- <ShowcaseAD /> -->
  </div>
</template>

<script>
import Banner from '@/modules/home/Banner.vue'
import Showcase from '@/modules/home/Showcase.vue'
import News from '@/modules/home/News.vue'
import PageFeed from '@/modules/home/PageFeed.vue'
// import ShowcaseAD from '@/modules/home/ShowcaseAD.vue'

export default {
  components: {
    Banner,
    Showcase,
    News,
    PageFeed,
    // ShowcaseAD,
  },
  props: {
    styles: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    news: {
      type: Array,
      default: () => [],
    },
    banners: {
      type: Array,
      default: () => [],
    },
    videos: {
      type: Array,
      default: () => [],
    },
    posts: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    enableStyleFilter() {
      // 客戶還未決定上線"生活型態"所以enableStyleFilter設定false，
      // 登入後台，或是網址加上 ?enableStyleFilter=true 來進行測試
      return this.settings.enableStyleFilter || !!this.$user || this.$route.path.indexOf('/2022/') === 0
    }
  },
  mounted() {
    document.querySelector('.top-menu').style.position = 'fixed'
    document.querySelector('body').setAttribute('id', 'homePage')
    document.querySelector('#pageLoading').style.display = 'none'
  },
  methods: {
    getRandomLabel(motor) {
      const style = this.styles.find((s) => s.motors.map((m) => m.id).includes(motor.id))
      return style && style.name
    },
  },
}
</script>

<style lang="stylus">

// html
//   overflow-x hidden
// NOTE 不可以對 html 使用 overflow hidden 會造成捲軸位置判斷錯誤

body
  position relative
  overflow-x hidden
  overflow-y auto
  width 100%
  left 0
  top 0
  right 0
  @media (max-width 768px)
    width calc(100vw - 0.5em) //不知道為什麼在手機時，y軸會暫空間，讓body溢出html容器

.home-page-2022
  max-width 100vw
  margin-top: 60px;
  @media (max-width 768px)
    // margin-top 60px
  // overflow-x hidden
  a:hover
    color inherit
  > .section
    overflow hidden
  .button--more
    color #333
    border 1px solid #AAA
    padding .75em 1em
    background white
    font-size 1.2rem
    display block
    letter-spacing .25em
    border-radius 25px
    text-align center
    align-items center
    justify-content center

body > .side_nav
  a
    margin-bottom 0em

.container.w1680
  @media (min-width 768px)
    max-width 1680px
    width calc(100vw - 80px)

.link-zoom-image
  img
    transform scale(1)
    transition transform cubic-bezier(.4, 0, .2, 1) .3s
  &:hover img
    transform scale(1.05)

.link-cardly
  backface-visibility visible // IE11 閃爍BUG
  transform translate3d(0, 0, 0)
  transition transform .3s
  display inline-block
  cursor pointer
  &:hover
    transform translateY(-5px) translateZ(0)
</style>

<style lang="stylus" scoped>
.scaffold
  outline 1px solid #999
  min-height 200px
  padding 1em

.section.main-slider
  max-height 700px
  max-width 2000px
</style>
